import styled from 'styled-components';
import { GlobalToken } from 'antd';

const title = `
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  text-transform: uppercase;
`;

export const OverviewContainer = styled.div<{ theme: { token: GlobalToken } }>`
  height: 100%;
  display: flex;
  flex-direction: column;

  .spinner {
    height: 350px;
  }

  .flex-row {
    display: flex;
    justify-content: space-between;
  }

  .title {
    ${title}
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    margin: ${({ theme: { token } }) => token.margin}px 0 0 ${({ theme: { token } }) => token.marginXXS}px;
  }

  .card-title {
    ${title}
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
  }

  .horizontal-line {
    height: 1.5px;
    margin: ${({ theme: { token } }) => token.marginXS}px 0 ${({ theme: { token } }) => token.margin}px 0;
  }

  .card {
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    border-radius: 2px;
    width: 286px;
    padding: ${({ theme: { token } }) => token.paddingSM}px 0 ${({ theme: { token } }) => token.paddingXS}px
      ${({ theme: { token } }) => token.padding}px;
  }

  .donut-charts {
    flex-grow: 0.2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-self: flex-end;
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .rejected-title {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  }
  .lifetime-action-count-details {
    margin: ${({ theme: { token } }) => token.marginXL}px 0 0 0;
  }
`;

export const ActionCountDetailsContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ theme: { token } }) => token.marginXXS}px;

  .action-count-details-skeleton {
    width: fit-content;
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;
  }

  .action-count-chip-skeleton {
    width: fit-content;
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .action-count {
    display: flex;
    align-items: center;
    font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .action-rejected {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .chip {
    background-color: ${({ theme: { token } }) => token.colorError};
    line-height: ${({ theme: { token } }) => token.lineHeightHeading3};
  }

  .background-color-grey {
    background-color: ${({ theme: { token } }) => token.colorBorder};
  }

  .background-color-red {
    background-color: ${({ theme: { token } }) => token.colorError};
  }

  .background-color-green {
    background-color: ${({ theme: { token } }) => token.colorSuccess};
  }

  .font-size-big {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
  }

  .label {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }
`;
